// // src/pages/LandingPage.tsx
// import React, { useMemo, useState } from "react";
// import { LandingStyles } from "../components/landing/LandingStyles";
// import { LandingHeader } from "../components/landing/LandingHeader";
// import { HeroSection } from "../components/landing/HeroSection";
// import { FilterBar } from "../components/landing/FilterBar";
// import { ListingGrid } from "../components/landing/ListingGrid";
// import { HowItWorks } from "../components/landing/HowItWorks";
// import { OwnerCTA } from "../components/landing/OwnerCTA";
// import { Footer } from "../components/landing/Footer";
// import { useBrandListings } from "../hooks/useBrandListings";
// import { BrandListingFilters } from "../types/brandlistingsmodel";

// export default function LandingPage() {
//   const [filters, setFilters] = useState<BrandListingFilters>({});
//   const [query, setQuery] = useState("");
//   const [page, setPage] = useState(1);

//   const { listings, total, isLoading, error } = useBrandListings(filters);

//   // Client-side text search on top of the server-filtered results —
//   // the API has no free-text search param, so this narrows what's
//   // already been fetched for the current State/City/MediaType/price filter.
//   const visibleListings = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return listings;
//     return listings.filter(
//       (l) =>
//         l.title.toLowerCase().includes(q) ||
//         l.area.toLowerCase().includes(q) ||
//         l.city.toLowerCase().includes(q)
//     );
//   }, [listings, query]);

//   const cityCount = useMemo(() => new Set(listings.map((l) => l.city)).size, [listings]);

//   const handleFiltersChange = (next: BrandListingFilters) => {
//     setFilters(next);
//     setPage(1);
//   };

//   const handleSearch = (q: string) => {
//     setQuery(q);
//     setPage(1);
//   };

//   return (
//     <div className="adroj-landing min-h-screen bg-white text-[#0F172A]">
//       <LandingStyles />

//       <LandingHeader />
//       <HeroSection listings={listings} total={total} cityCount={cityCount} onSearch={handleSearch} />

//       <FilterBar filters={filters} onChange={handleFiltersChange} resultCount={visibleListings.length} isLoading={isLoading} />

//       <section id="listings" className="mx-auto max-w-[90%] px-5 py-14 sm:px-8">
//         <div className="mb-8 flex items-end justify-between">
//           <div>
//             <span className="text-[11px] font-semibold uppercase tracking-wider text-[#1D9BD8]">Available now</span>
//             <h2 className="font-display mt-2 text-3xl text-[#0F172A]">
//               {isLoading ? "Loading spaces..." : `${visibleListings.length} advertising space${visibleListings.length === 1 ? "" : "s"}`}
//             </h2>
//           </div>
//         </div>

//         <ListingGrid listings={visibleListings} isLoading={isLoading} error={error} page={page} onPageChange={setPage} />
//       </section>

//       <HowItWorks />
//       <OwnerCTA />
//       <Footer />
//     </div>
//   );
// }





//==========================




// src/pages/LandingPage.tsx
import React, { useMemo, useState } from "react";
import { LandingStyles } from "../components/landing/LandingStyles";
import { LandingHeader } from "../components/landing/LandingHeader";
import { HeroSection } from "../components/landing/HeroSection";
import { FilterBar } from "../components/landing/FilterBar";
import { ListingGrid } from "../components/landing/ListingGrid";
import { HowItWorks } from "../components/landing/HowItWorks";
import { ContactSection } from "../components/landing/ContactSection";
import { OwnerCTA } from "../components/landing/OwnerCTA";
import { Footer } from "../components/landing/Footer";
import { useBrandListings } from "../hooks/useBrandListings";
import { BrandListingFilters } from "../types/brandlistingsmodel";

export default function LandingPage() {
  const [filters, setFilters] = useState<BrandListingFilters>({});
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);

  const { listings, total, isLoading, error } = useBrandListings(filters);

  // Client-side text search on top of the server-filtered results —
  // the API has no free-text search param, so this narrows what's
  // already been fetched for the current State/City/MediaType/price filter.
  const visibleListings = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return listings;
    return listings.filter(
      (l) =>
        l.title.toLowerCase().includes(q) ||
        l.area.toLowerCase().includes(q) ||
        l.city.toLowerCase().includes(q)
    );
  }, [listings, query]);

  const cityCount = useMemo(() => new Set(listings.map((l) => l.city)).size, [listings]);

  const handleFiltersChange = (next: BrandListingFilters) => {
    setFilters(next);
    setPage(1);
  };

  const handleSearch = (q: string) => {
    setQuery(q);
    setPage(1);
  };

  return (
    <div className="adroj-landing min-h-screen bg-white text-[#0F172A]">
      <LandingStyles />

      <LandingHeader />
      <HeroSection listings={listings} total={total} cityCount={cityCount} onSearch={handleSearch} />

      <FilterBar filters={filters} onChange={handleFiltersChange} resultCount={visibleListings.length} isLoading={isLoading} />

      <section id="listings" className="mx-auto max-w-[90%] px-5 py-14 sm:px-8">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <span className="text-[11px] font-semibold uppercase tracking-wider text-[#1D9BD8]">Available now</span>
            <h2 className="font-display mt-2 text-3xl text-[#0F172A]">
              {isLoading ? "Loading spaces..." : `${visibleListings.length} advertising space${visibleListings.length === 1 ? "" : "s"}`}
            </h2>
          </div>
        </div>

        <ListingGrid listings={visibleListings} isLoading={isLoading} error={error} page={page} onPageChange={setPage} />
      </section>

      <ContactSection />
      <HowItWorks />
      <OwnerCTA />
      <Footer />
    </div>
  );
}